import { getOffset, RippleEffect } from '../../../utils';

export const ClickRippleMixin = {
    data() {
        return {
            ripple: null,
            rippleConfig: {
                container: null,
                color: `rgba(255, 255, 255, .2)`,
                position: {
                    x: null,
                    y: null
                },
                halfAnimationSize: 0.75,
                duration: 800
            }
        }
    },
    methods: {
        startRipple(event) {
            if (this.ripple && !this.ripple.isComplete) {
                this.ripple.fullAnimation();
            }

            if (this.disabled) {
                return;
            }

            const offset = getOffset(event);
            this.ripple = this.createRipple(
                this.rippleConfig.position.x || `${offset.x}px`,
                this.rippleConfig.position.y || `${offset.y}px`
            );
            this.ripple.halfAnimation();
        },
        endRipple() {
            if (this.ripple) {
                this.ripple.fullAnimation();
            }
        },
        cancelRipple() {
            if (this.ripple) {
                this.ripple.cancel();
            }
        },
        createRipple(x, y) {
            const rippleEffect = new RippleEffect(this.rippleConfig.container);

            rippleEffect
                .backgroundColor(this.rippleConfig.color)
                .duration(this.rippleConfig.duration)
                .halfAnimationSize(this.rippleConfig.halfAnimationSize)
                .position(x, y);

            return rippleEffect;
        }
    }
};
